module.exports = __webpack_public_path__ + "static/media/zelos.a00b0ff0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/stay/zelos.jpg
// module id = 580
// module chunks = 0